import { useParams } from "react-router-dom";
import { useDebounceValue, useStateWithSearchParams } from "../../../hooks";
import {
  useGenerateAccountPlansCSVForCampaignMutation,
  useGetAccountsPlanListQuery,
} from "../../../api";
import { ExportCSVModal } from "./ExportCSVModal";
import { useMemo } from "react";
import { AccountPlanStatus } from "../../../types/enums";

type SearchParams = {
  sizes?: string;
  industries?: string;
  regions?: string;
  search?: string;
  sort?: string;
  page?: string;
  per_page?: string;
  selected?: string;
  limit?: string;
  date?: string;
};

export const ExportAccountPlansFromCampaignModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const { campaign_id } = useParams();

  const { searchDict } = useStateWithSearchParams<SearchParams>({
    search: undefined,
  });

  const querySearchValueDebounce = useDebounceValue(searchDict.search || "");

  const [generateAccountPlansCSV, { isLoading: isGenerationCSV }] =
    useGenerateAccountPlansCSVForCampaignMutation();

  const { data: companies, isLoading } = useGetAccountsPlanListQuery(
    {
      campaign_id: campaign_id!,
      per_page: 1000,
      search: querySearchValueDebounce || undefined,
      status_filter: AccountPlanStatus.completed,
    },
    { refetchOnMountOrArgChange: true },
  );

  const submitHandler = (
    account_ids: string[],
    fileName: string,
    isSelectedAll: boolean,
  ) => {
    return generateAccountPlansCSV({
      campaign_id: campaign_id!,
      account_ids,
      file_name: fileName.trim(),
      all_accounts: isSelectedAll,
    }).unwrap();
  };

  const items = useMemo(
    () =>
      (companies?.items || [])?.map((company) => ({
        ...company,
        name: company.account_name,
        id: company.account_id,
        is_analyzed: true,
      })),
    [companies],
  );

  return (
    <ExportCSVModal
      title={"Export Account Plan Links to CSV"}
      description={
        "For which accounts would you like to export account plan links?"
      }
      items={items}
      isLoading={isGenerationCSV || isLoading}
      onSubmit={submitHandler}
      onClose={onClose}
      submitBtnText={"Export Links"}
    />
  );
};
